import React, { useEffect, useState } from "react"
import { Form, Icon } from "semantic-ui-react"
import { CurrencyExchange } from "../../api/services/next"
import { MenuActions } from "../../components/shared/constants"
import CurrencyInput from "../../components/shared/CurrencyInput"
import { DatePicker } from "../../components/shared/DatePicker"
import HotelsDropDown from "../../components/shared/HotelsDropDown"
import { onError, onSuccess } from "../../components/shared/messages"
import { useTextResources } from "../../language"
import GridSearchTemplate from '../GridSearchTemplate'
import { onUpdateGridHandler } from "../../components/GridPanel/utility"
import { useLoader } from "../../hooks/useLoader"

export const HotelCurrencyPage = ()=>{
    const text = useTextResources()
    const loader = useLoader()
    const [data, setData] = useState([])
    const [spec, setSpec] = useState({
        HotelId: window.optima?.user?.CurrentHotel?.Id,
        Date: new Date()
    })

    
    const CurrencyEditor = ({row, ...rest})=>{
        return <CurrencyInput currency={row.CurrencySymbol} digits={6} {...rest}/>
    }
    const CheckIcon = ({value})=>(value?<Icon name="check"/>:null)
     

    const save = async () => {
        (async () => {
            try {
                loader(true)   
                await CurrencyExchange.UpdateHotelCurrencyExchangeRates ({
                    ...spec,
                    // Send changed and already manually edited
                    Updated: data.filter(x=>x.ManualEdit)
                })                                
                onSuccess()
            } catch (error) {
                onError(error)
            } finally {
                loader(false)
            }
        })()
    }

    useEffect(() => {
        if (window.optima?.commands) {
            window.optima.commands.unsubscribe(MenuActions.save)
            window.optima.commands.subscribe(MenuActions.save, save);
        }
    }, [data])

    const onUpdate = (added, changed) => {
        const updated = onUpdateGridHandler(data,added,changed);
        for (const key in changed) {
            updated[key].ManualEdit = true
        }
        setData(updated);
    }
    

    const gridOptions = {
        search: {
            fields: [
                <Form.Field control={HotelsDropDown} label= {text("Hotel")} key="HotelId" name="HotelId" />,
                <DatePicker 
                    type="basic"
                    label= {text("Date")} 
                    clearable={false}
                    name="Date"
                    key="Date"
                />
            ],
            initial: spec,
            api: CurrencyExchange.GetHotelCurrencyExchangeRates,
            searchOnLoad: true
        },
        grid: {
            columns: [
                { name: 'CurrencyName', title: text("Currency") },
                { name: 'PublicRate', title: text("PublicRate") },
                { name: 'ExchangeRate', title: text("ExchangeRate"), editor: <CurrencyEditor/> },
                { name: 'PaymentRate', title: text("PaymentRate"), editor: <CurrencyEditor/>},
                { name: 'ManualEdit', title: text("ManualEdit"), formatter: ({value})=>value?<Icon name="check"/>:null, editor: <CheckIcon/>  }
            ],
            editable: {
                allowAdd: false,
                allowEdit: true
            },
            columnExtensions:[
                { columnName: 'CurrencyName', editingEnabled: false },
                { columnName: 'PublicRate', editingEnabled: false },
                { columnName: 'ManualEdit', editingEnabled: false }
            ],
        }
    }
    return <GridSearchTemplate options={gridOptions} data={data} onGridUpdate={onUpdate} onSearchChange={()=>setData([])} onSearchComplete={(data, state)=>{
        setSpec(state)
        setData(data)
    }}/>
}